import httpClient from './httpClient';

const base = '/api/contifico';

// Configuración
export const getConfig         = ()       => httpClient.get(`${base}/config`);
export const guardarConfig     = (datos)  => httpClient.put(`${base}/config`, datos);

// Ping — acepta credenciales opcionales para probar antes de guardar
export const pingContifico = (api_key, api_token) => {
  const query = api_key && api_token
    ? `?api_key=${encodeURIComponent(api_key)}&api_token=${encodeURIComponent(api_token)}`
    : '';
  return httpClient.get(`${base}/ping${query}`);
};

// Sincronización manual de entidades
export const syncEstudiante = (id) => httpClient.post(`${base}/sync/estudiante/${id}`);
export const syncEmpleado   = (id) => httpClient.post(`${base}/sync/empleado/${id}`);
export const syncCurso      = (id) => httpClient.post(`${base}/sync/curso/${id}`);

// Facturas emitidas
export const listarFacturas = ({ fecha_inicial, fecha_final, estado, page, page_size } = {}) => {
  const params = new URLSearchParams();
  if (fecha_inicial) params.append('fecha_inicial', fecha_inicial);
  if (fecha_final)   params.append('fecha_final',   fecha_final);
  if (estado)        params.append('estado',        estado);
  if (page)          params.append('page',          page);
  if (page_size)     params.append('page_size',     page_size);
  const qs = params.toString();
  return httpClient.get(`${base}/facturas${qs ? `?${qs}` : ''}`);
};

export const estadoFactura = (id) => httpClient.get(`${base}/facturas/${id}/estado`);

// Facturas locales generadas desde Ademy (tabla facturas)
export const listarFacturasLocales = ({ fecha_inicial, fecha_final, estado_sri, page, page_size } = {}) => {
  const params = new URLSearchParams();
  if (fecha_inicial) params.append('fecha_inicial', fecha_inicial);
  if (fecha_final)   params.append('fecha_final',   fecha_final);
  if (estado_sri)    params.append('estado_sri',    estado_sri);
  if (page)          params.append('page',          page);
  if (page_size)     params.append('page_size',     page_size);
  const qs = params.toString();
  return httpClient.get(`${base}/facturas-locales${qs ? `?${qs}` : ''}`);
};

// Consulta de documentos Contífico
export const obtenerDocumentoContifico = (id) => httpClient.get(`${base}/documento/${id}`);

// Catálogo de productos (caché local)
export const listarProductosContifico = () => httpClient.get(`${base}/productos`);
export const toggleProductoContifico  = (id, activo) => httpClient.patch(`${base}/productos/${id}/activo`, { activo });
export const syncCatalogo             = () => httpClient.post(`${base}/sync/catalogo`);

// Bodegas reales de Contífico en vivo (sin cache) — para enlazar a mano
// desde Inventario en vez de que el sync adivine por nombre exacto.
export const listarBodegasContifico = () => httpClient.get(`${base}/bodegas`);

// Compras PRO (facturas recibidas de proveedores/docentes desde Contífico)
export const listarComprasContifico = ({ fecha_inicial, fecha_final, persona_id, page, page_size } = {}) => {
  const params = new URLSearchParams();
  if (fecha_inicial) params.append('fecha_inicial', fecha_inicial);
  if (fecha_final)   params.append('fecha_final',   fecha_final);
  if (persona_id)    params.append('persona_id',    persona_id);
  if (page)          params.append('page',          page);
  if (page_size)     params.append('page_size',     page_size);
  const qs = params.toString();
  return httpClient.get(`${base}/compras${qs ? `?${qs}` : ''}`);
};

// Notas de crédito emitidas (NCT)
export const listarNotasCredito = ({ fecha_inicial, fecha_final, estado, page, page_size } = {}) => {
  const params = new URLSearchParams();
  if (fecha_inicial) params.append('fecha_inicial', fecha_inicial);
  if (fecha_final)   params.append('fecha_final',   fecha_final);
  if (estado)        params.append('estado',        estado);
  if (page)          params.append('page',          page);
  if (page_size)     params.append('page_size',     page_size);
  const qs = params.toString();
  return httpClient.get(`${base}/notas${qs ? `?${qs}` : ''}`);
};

// Reintenta manualmente una factura local rechazada
export const reintentarFacturaLocal = (id) =>
  httpClient.post(`${base}/facturas-locales/${id}/reintentar`);

// Genera nota de crédito NCT para revertir una factura autorizada por el SRI
export const anularFactura = (contificoId, motivo) =>
  httpClient.post(`${base}/anular/documento/${contificoId}`, { motivo });

// Anulación directa: cambia el estado del documento a 'A' en Contífico (sin NCT)
export const anularDocumentoDirecto = (contificoId) =>
  httpClient.patch(`${base}/anular-directo/documento/${contificoId}`, {});

// Conceptos de pago — mapeo a productos Contífico
export const listarConceptos        = ()          => httpClient.get(`${base}/conceptos`);
export const actualizarConcepto     = (id, datos) => httpClient.put(`${base}/conceptos/${id}`, datos);

// Cuentas bancarias (para cobros por transferencia/depósito)
export const listarCuentasBancarias = () => httpClient.get(`${base}/cuentas-bancarias`);

// Catálogo de cuentas bancarias (caché local) — mismo patrón que el catálogo de productos
export const listarCuentasBancariasCatalogo = () => httpClient.get(`${base}/cuentas-bancarias/catalogo`);
export const toggleCuentaBancaria           = (id, activo) => httpClient.patch(`${base}/cuentas-bancarias/${id}/activo`, { activo });
export const syncCuentasBancarias           = () => httpClient.post(`${base}/sync/cuentas-bancarias`);
